export default __webpack_public_path__ + "static/media/CL.3df6783e.svg";